<template>
  <div>
    <b-row>
      <b-col cols="12" lg="4">
        <statistic-card-horizontal icon="fas fa-sign-in-alt" v-bind:statistic="`${stats.totalServices || 0} (${(stats.providers||[]).length || 0})`"
                                   v-bind:loading="loadingStats"
                                   :statistic-title="$t('providerStats.services')"
                                   icon-type="fontawesome" color="primary">
          <template v-slot:footer>
            <span class="text-secondary" >{{$t('providerStats.completedServices')}}: {{stats.totalCompletedServices || 0}}</span>
          </template>
        </statistic-card-horizontal>
      </b-col>
      <b-col cols="12" lg="4">
        <statistic-card-horizontal icon="fa-solid fa-receipt" v-bind:statistic="`${stats.totalExpenses || 0} €`" v-bind:loading="loadingStats"
                                   :statistic-title="$t('providerStats.expenses')"
                                   icon-type="fontawesome" color="warning">
          <template v-slot:footer>
            <span class="text-secondary" >{{$t('providerStats.pendingExpenses')}}: {{stats.totalPendingExpenses || 0}} €</span>
          </template>
        </statistic-card-horizontal>
      </b-col>
      <b-col cols="12" lg="4">
        <statistic-card-horizontal icon="fa-solid fa-chart-line" v-bind:statistic="`${stats.totalRevenue || 0} €`" v-bind:loading="loadingStats"
                                   :statistic-title="$t('providerStats.revenue')"
                                   icon-type="fontawesome" color="success">
          <template v-slot:footer>
            <span class="text-secondary" >{{$t('providerStats.pendingRevenue')}}: {{stats.totalPendingRevenue || 0}} €</span>
          </template>
        </statistic-card-horizontal>
      </b-col>
    </b-row>
    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refreshAll()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>

        <b-row>
          <!--Copied from realEstateContracts.vue-->
          <b-col md="3" class="">
            <b-form-group :label="msg('serviceTime')">
              <calendar-picker-range v-model="filter.serviceTime"/>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label style="margin-bottom: 8px ">{{ msg("Provider") }}</label>
            <providers-search multiple v-model="filter.providerId"/>
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Status')">
              <v-select multiple
                        :clearable="true"
                        v-model="filter.statuses"
                        :options="allStatuses"
                        class="w-100"
                        label="text"
                        :reduce="(branch) => branch.value"

              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!--Card Content-->
    <b-card no-body>
      <b-card-header style="overflow: hidden">
        <span class="card-title m-0">{{ msg('Providers') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="addNewProvider()">
              <feather-icon icon="PlusIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </b-card-header>
      <!--Table-->
      <provider-service-table v-bind:filter="filter" ref="provider-table"/>
    </b-card>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProvidersSearch from "@/components/widgets/picker/providersSearch.vue";
import CalendarPickerRange from "@/components/widgets/calendar/calendarPickerRange.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import ProviderServiceTable from "@/components/tables/ProviderServiceTable.vue";

export default {
  name: "providers",
  components: {ProviderServiceTable, StatisticCardHorizontal, CalendarPickerRange, ProvidersSearch},
  data: () => ({
    loadingStats: true,
    filter: {providerId: null, statuses:null,contact:null, serviceTime: {start: null, end: null}},
    stats:{},
  }),
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refreshStats();
      }
    },
  },
  created() {
    this.filter.serviceTime = {start: this.$moment().startOf('month').format('YYYY-MM-DD'), end: this.$moment().endOf('month').format('YYYY-MM-DD')};
    this.refreshStats();
  },
  computed: {
    allStatuses() {
      let statuses = this.$t(`providerServiceStatus`);
      return Object.keys(statuses).map((key) => {
        return {value: key, text: this.$t(`providerServiceStatus.${key}`)}
      });
    },
  },
  methods: {
    ...mapActions('providersServices', ['fetchProviderRevenueStats']),
    refreshAll(){
      this.refreshStats();
      this.refresh();
    },
    refreshStats(){
      let $this = this;
      this.loadingStats = true;
      let filter = {...this.filter, statuses: null}
      this.fetchProviderRevenueStats(filter).then(stats => {
        this.stats = stats;
      }).catch(error => {
        console.error("Error fetching provider revenue stats", error);
      }).finally(() => {
        this.loadingStats = false;
      });
    },
    refresh() {
      this.$refs['provider-table'].refresh();
    },
    addNewProvider() {
      // this.$refs.guestFeatureModal.addNewFeature();
    },
  }
}
</script>


<style scoped>

</style>